webpackJsonp([16978868906507],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(46);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _home = __webpack_require__(53);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcercaDe = function AcercaDe(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'acerca-layout' },
	    _react2.default.createElement(_gatsbyImage2.default, {
	      sizes: data.imageSharp.sizes,
	      style: { zIndex: '-1', position: 'absolute' },
	      className: 'main-bg'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Fiorella Pattoni'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Mis piezas se caracterizan por tener simetr\xEDa y son de formas org\xE1nicas. Me gusta tener de referencia; lenguajes textiles como tejidos y encajes, elementos y gestos de la naturaleza. Dise\xF1ar patrones que logren hacer de una pieza de joyer\xEDa, arte utilitario.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'La relaci\xF3n que poseemos hacia los ornamentos que utilizamos, nos transforman, nos empoderan y terminan de configurar nuestra imagen. Somos una idea dise\xF1ada por nosotros mismos, somos un discurso inventado y \xFAnico, as\xED como cada una de las piezas que elaboro.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Creo que las cosas trascienden m\xE1s all\xE1 de lo que son y que una pieza de joyer\xEDa, puede ser un sentimiento, una decisi\xF3n, un lugar, una persona, una experiencia, un discurso escrito de otra forma.'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        _react2.default.createElement(
	          'a',
	          { className: 'back', href: '/' },
	          _react2.default.createElement(_home2.default, null)
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = AcercaDe;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-acerca-de-js-fcdbe5c733ab88d563ad.js